export const DWOLLA_WEB_STABLE_URL = 'https://cdn.dwolla.com/v2.2.0/dwolla-web.js';
